import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-group',
  templateUrl: './listing-group.component.html',
  styleUrls: ['./listing-group.component.css']
})
export class ListingGroupComponent implements OnInit {
@Input() server_user_id=0
@Input() subscriptionGroupList=[]
dtOptions: DataTables.Settings = {}
  constructor() { }

  ngOnInit(): void {

  }

}
